export default "__VITE_ASSET__55b184c0__"